export const FETCH_TRENDING = "FETCH_TRENDING";
export const FETCH_POPULAR = "FETCH_POPULAR";
export const FETCH_TOP_RATED = "FETCH_TOP_RATED";
export const FETCH_NOW_PLAYING = "FETCH_NOW_PLAYING";

export const FETCH_DETAILS = "FETCH_DETAILS";
export const FETCH_CAST = "FETCH_CAST";

export const ADD_MOVIE = "ADD_MOVIE";
export const REMOVE_MOVIE = "REMOVE_MOVIE";
export const GET_ALL_MOVIES = "GET_ALL_MOVIES";
export const GET_ALL_IDS = "GET_ALL_IDS";

export const SEARCH_MOVIE = "SEARCH_MOVIE";
